<template>
  <div>
    <loading :active.sync="isLoading"></loading>
    <Navbar></Navbar>
    <div class="container">
      <div class="row text-center">
        <div class="col-lg-6">
          <!-- <a href="#" @click.prevent="judgeFavorite">
						<i class="fa-heart fa-2x position-absolute" :class="heartIcon"></i>
          </a>-->
          <img :src="carouselIMG[0]" class="img-fluid" alt />
          <!-- <div class="swiper-wrapper">
				<div class="swiper-slide">
					<img :src="imgurl">
				</div>
          </div>-->
          <!-- <div class="thumb-example"> -->
          <!-- swiper1 -->
          <!-- <swiper class="swiper gallery-top" :options="swiperOptionTop" ref="swiperTop" >
          <img :src="item" class="swiper-slide" v-for="item in carouselIMG" :key="item.id">-->
          <!-- <swiper-slide class="slide-1"></swiper-slide>
			<swiper-slide class="slide-2"></swiper-slide>
			<swiper-slide class="slide-3"></swiper-slide>
			<swiper-slide class="slide-4"></swiper-slide>
          <swiper-slide class="slide-5"></swiper-slide>-->
          <!-- <div class="swiper-button-next swiper-button-black" slot="button-next"></div>
			<div class="swiper-button-prev swiper-button-black" slot="button-prev"></div>
          </swiper>-->
          <!-- swiper2 Thumbs -->
          <!-- <swiper class="swiper gallery-thumbs" :options="swiperOptionThumbs" ref="swiperThumbs">
			<img :src="item" class="swiper-slide" v-for="item in carouselIMG" :key="item.id">
			</swiper>
          </div>-->
        </div>
        <div class="col-lg-6">
          <div class="product-text" v-if="(product.preOrder)">
            <h1 class="h2 title-border-bottom d-inline-block pb-2" style="color:red">--預購商品--</h1>
          </div>
          <div class="product-text">
            <h1 class="h2 title-border-bottom d-inline-block pb-2">{{product.name}}</h1>
          </div>

          <div class="text-left mt-3" v-if="(product.productType)">
            <span class="product-text-before">分類：</span>
            <router-link tag="a" class="product-text-after" to="/index" @click.native="search('type',product.type)"><span>{{product.productType}}</span></router-link>
            <!-- <a class="product-text-after" href="#" @click="search('type',product.type)">{{product.productType}}</a> -->
          </div>
          <div class="text-left mt-3" v-if="(product.productMiddleType)">
            <span class="product-text-before">子分類：</span>
            <router-link tag="a" class="product-text-after" to="/index" @click.native="search('middleType',product.middleType,product.type)"><span>{{product.productMiddleType}}</span></router-link>
            <!-- <a class="product-text-after" href="#"
              @click="search('middleType',product.middleType)">{{product.productMiddleType}}</a> -->
          </div>
          <div class="text-left mt-3">
            <span class="product-text-before">商品代碼：</span>
            <span class="product-text-after">{{product.commoditycode}}</span>
          </div>
          <div class="text-left mt-3" v-if="(product.simple)">
            <span class="product-text-before">簡要說明：</span>
            <span class="product-text-after">{{product.simple}}</span>
          </div>
          <div class="text-left mt-3" v-if="(product.consume)">
            <span class="product-text-before">消費說明：</span>
            <span class="product-text-after-important">{{product.consume}}</span>
          </div>
          <div class="text-left mt-3" v-if="(product.prompt)">
            <span class="product-text-before">結單提示：</span>
            <span class="product-text-after-important">{{product.prompt}}</span>
          </div>
          <div class="text-left mt-3" v-if="Object.keys(product.standards[0]).length == 0 && product.preOrder==0">
            <span class="product-text-before">庫存：</span>
            <span class="product-text-after-important"  v-if="token">{{productLimit}}</span>
             <span class="product-text-after-important"  v-else>?</span>
          </div>

          <div class="text-left mt-3" v-for="(item, index) in option" :key="item.id" v-if="option[0][0]">
            <span class="product-text-before" style="color:gray">{{optionTmp[index].name}}</span>
            <!-- <b-form-select v-model="selectId[optionTmp[index].standardsId]" :options="option[index]"
              @change="changeSelect()"></b-form-select> -->

            <!-- <b-form-group style="padding-top:2%;">
                <b-form-radio-group  v-model="selectId[optionTmp[index].standardsId]" :options="option[index]" @change="changeSelect()">
                </b-form-radio-group>
              </b-form-group> -->
            <div class="radio-inline" v-for="(item2, index2) in item" :key="index2.id">
              <span v-if="token">
                <input type="radio" v-model="selectId[optionTmp[index].standardsId]" :value="item2.value"
                  @change="changeSelect()">
                <span>{{item2.text}}</span>
                <span v-if="index==0" >
                  <span v-if="preOrder">...庫存{{optionTmp[index][index2].quantityLimit}}</span><!-- 判斷是否為有規格的預購，如是預購不顯示庫存 -->
                </span>
                <span v-if="index==0" class="option-price">　　${{optionTmp[index][index2].wholesale}}元</span>
                <br />
              </span>
               <span v-else>
                <input type="radio" v-model="selectId[optionTmp[index].standardsId]" :value="item2.value"
                  @change="changeSelect()">
                <span>{{item2.text}}</span>
                <span v-if="index==0" >...庫存?</span>
                <span v-if="index==0" class="option-price">　　$?元</span>
                <br />
              </span>

            </div>

          </div>

          <div class="text-left mt-3">
            <span class="product-text-before">我要開團：</span>
            <span class="product-text-after-important" >
               <toggle-button :value="false" :sync="true" color="#82C7EB" :labels="true" hight="30" @change="checkGroup"
                                v-model="openGroup" />
            </span>
          </div>

          <div class="text-left mt-3">
            <span class="product-text-before" v-if="product.unit>1">*購買單位必須是
              {{product.unit}},{{product.unit*2}},{{product.unit*3}} 件</span>
          </div>

          <div class="text-left mt-3">
            <span class="product-text-before" v-if="product.less>0">*最少需買{{product.less}}(含)件以上</span>
            <span class="product-text-before" v-if="product.more>0">*最多只能買{{product.more}}(含)件</span>
          </div>

          <div class="card-footer pt-0 pb-4 price-under" v-if="token">
            <!-- <p class="text-right text-muted mb-0"><del>原價：{{product.memberPricediscount | currency}}</del></p> -->

            <p class="h3 text-right mb-0" v-if="admin=='1'">實際成本價：{{productRealCost | currency}}</p>
            <p class="h3 text-right mb-0" v-if="shop=='1' || shop=='2' "><span
                v-if="!product.preOrder || admin=='1'">成本價：{{productCost | currency}}</span></p>
            <p class="h3 text-right mb-0">批發價：{{productPrice | currency}}</p>

          </div>
          <div class="card-footer pt-0 pb-4 price-under" v-else>
            <p class="h3 text-right mb-0">成本價：?</p>
            <p class="h3 text-right mb-0">批發價：?</p>
            <!-- <p class="text-right text-muted mb-0">
              <del>原價：?</del>
            </p>
            <p class="h3 text-right mb-0">會員價：?</p>-->
          </div>

          <div class="input-group mb-3 input-group-under" v-if="canbuy">
            <div class="input-group-prepend">
              <button class="btn btn-outline-secondary px-sm-5 btn-num" type="button" @click.prevent="minNum">-</button>
            </div>
            <div class="custom-file ">
              <input type="number" class="form-control text-center-num " v-model.number="productNum"
                @input="updateValue" onkeyup="value=value.replace(/[^\d]/g, '').replace(/^0{1,}/g,'')" />
            </div>
            <div class="input-group-prepend">
              <button class="btn btn-outline-secondary px-sm-5 btn-num" type="button"
                @click.prevent="productNum = parseInt(productNum)+parseInt(product.unit)">+</button>
              <button class="btn btn-secondary font-weight-bolder btn-cart" type="button"
                @click.prevent="addtoCart(productNum)">{{bottonText}}</button>
            </div>
          </div>

          <div class="mb-3" v-if="!canbuy">
            <div class="row">
              <div class="col-12 text-right">
                <button class="btn btn-danger font-weight-bolder btn-cart" type="button">{{canbuyText}}</button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <hr class="hr-line" />

      <div class="row">
        <div class="col-12 productDetailTitle">
          <a class="font-weight-bold">商品介紹</a>
          <br />
        </div>
        <div class="col-12" v-if="product.film !=null">
          <iframe :src="product.film" scrolling="no" frameborder="0" width="100%" height="430" allowfullscreen="true"
            webkitallowfullscreen="true" mozallowfullscreen="true"></iframe>
          <button type="button" class="btn btn-danger" @click="hyperlink">影片下載位置</button>
        </div>
        <div class="col-12">
          <div v-html="product.content"></div>
        </div>
        <div class="col-12" v-for="(item,key) in carouselIMG" :key="item.id">
          <img :src="item" class="img-fluid" alt />
        </div>
      </div>
    </div>

    <Footer></Footer>
  </div>
</template>

<script>
  import axios from "axios";
  import Navbar from "../../components/Layout/Navbar";
  import Footer from "../../components/Layout/Footer";

  export default {
    components: {
      Navbar,
      Footer
    },
    name: "productDetailed",
    data() {
      return {
        token: localStorage.getItem("usertoken"),
        tokenAdmin: localStorage.getItem("usertokenMaximumAuthority"), //取出token
        bottonText: "加入購物車", //按鈕文字
        canbuy: 1, //可否購買
        canbuyText: "", //無庫存文字
        isLoading: false, //加入讀取效果
        shopId: "", //商店id
        shop: "", //使用者會員等級
        admin: 0, //是不是管理員
        productId: "",
        // productAll: [], //所有同名稱產品
        product: {
          standards: [{}]
        }, //第一個產品
        productNum: 1, //購買數量
        productLimit: "", //數量
        productRealCost: 0, //產品實際成本價
        productCost: 0, //產品成本價格
        productPrice: 0, //產品價格
        openGroup: false, //我要開團
        imgUrl: "",
        content: "",
        option: [], //選項
        optionTmp: {}, //暫存選項
        carouselIMG: [], //商品輪播圖片
        selectId: {}, //要購買的id
        // swiperOptionTop: {
        //   loop: true,
        //   loopedSlides: 5, // looped slides should be the same
        //   spaceBetween: 10,
        //   navigation: {
        //     nextEl: ".swiper-button-next",
        //     prevEl: ".swiper-button-prev"
        //   }
        // },
        // swiperOptionThumbs: {
        //   loop: true,
        //   loopedSlides: 5, // looped slides should be the same
        //   spaceBetween: 10,
        //   centeredSlides: true,
        //   slidesPerView: "auto",
        //   touchRatio: 0.2,
        //   slideToClickedSlide: true
        // }
      };
    },
    methods: {
      //變更開團
      checkGroup(){
        const vm = this;
        const headers = {
          headers: {
            Authorization: "Bearer " + vm.token
          }
        };
        const data = {
          product_id:vm.productId,
          check:vm.openGroup
        };
        const me_api = `${process.env.APIPATH}/checkGroups`;
        axios
          .post(me_api, data, headers)
          .then(res => {

          })
          .catch(err => {
            console.log(err);
          });
      },
      //取得開團
      getGroup() {
        const vm = this;
        const headers = {
          headers: {
            Authorization: "Bearer " + vm.token
          }
        };
        const data = {
          product_id:vm.productId
        };
        const me_api = `${process.env.APIPATH}/getGroups`;
        axios
          .post(me_api, data, headers)
          .then(res => {
            vm.openGroup = res.data === 0 ? false:true;
          })
          .catch(err => {
            console.log(err);
          });
      },

      //取得權限
      getMe() {
        const vm = this;
        const headers = {
          headers: {
            Authorization: "Bearer " + vm.token
          }
        };
        const data = {};
        const me_api = `${process.env.APIPATH}/me`;
        axios
          .post(me_api, data, headers)
          .then(res => {

            vm.shop = res.data.shop;
            vm.admin = res.data.admin;
            vm.getProduct();
          })
          .catch(err => {
            console.log(err);
          });
      },
      //搜尋分類
      search(key, value,selectType) {
        const vm = this;
        if (key == "type") localStorage.removeItem("middleType");
        if (key == "middleType") localStorage.removeItem("type");
        localStorage.setItem('selectType',selectType)
        localStorage.setItem(key, value); //儲存EMAIL做完判斷是否有驗證用

      },
      //取得商品資料
      getProduct() {
        const vm = this;
        vm.isLoading = true;
        const data = {
          productId: vm.productId
        };
        const me_api = `${process.env.APIPATH}/productDetail`;
        axios
          .post(me_api, data)
          .then(res => {
            vm.isLoading = false;

            if (vm.admin == '1' || vm.tokenAdmin) {

            } else if (vm.shop == '0') {
              if (res.data.shop1 == '0') {
                alert('無此權限訪問此商品!!');
                vm.$router.push("/index");
              } else if (res.data.shop1 == '1' && res.data.preOrder) {
                alert('無此權限訪問此商品!!');
                vm.$router.push("/index");
              } else if (res.data.shop1 == '1') {

              } else {
                alert('無此權限訪問此商品!!');
                vm.$router.push("/index");
              }
            } else if (vm.shop == '1') {
              if (res.data.shop2 == '0') {
                alert('無此權限訪問此商品!!');
                vm.$router.push("/index");
              } else if (res.data.shop2 == '1') {

              } else {
                alert('無此權限訪問此商品!!');
                vm.$router.push("/index");
              }
            } else if (vm.shop == '2') {
              if (res.data.shop3 == '0') {
                alert('無此權限訪問此商品!!');
                vm.$router.push("/index");
              } else if (res.data.shop3 == '1') {

              } else {
                alert('無此權限訪問此商品!!');
                vm.$router.push("/index");
              }
            } else if (vm.shop == undefined) {
              if (res.data.shop1 == '0') {
                alert('無此權限訪問此商品!!');
                vm.$router.push("/index");
              } else if (res.data.shop1 == '1' && res.data.preOrder) {
                alert('無此權限訪問此商品!!');
                vm.$router.push("/index");
              } else if (res.data.shop1 == '1') {

              } else {
                alert('無此權限訪問此商品!!');
                vm.$router.push("/index");
              }
            } else {
              alert('無此權限訪問此商品!!');
              vm.$router.push("/index");
            }

            if (res.data) {
              // vm.productAll = res.data.data;
              vm.product = res.data;
              //檢查是否下架或刪除
              let today = new Date();
              let currentDateTime = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate() + ' ' +
                today.getHours() + ':' + today.getMinutes() + ':' + today.getSeconds();

              if (((vm.product.status == 0 || vm.product.status == 2 || vm.product.status == 4) && vm.admin != '1')) {
                alert("此商品已遭下架或刪除!!");
                vm.$router.push("/index");

              } else if (Date.parse(vm.product.reservation) > Date.parse(currentDateTime)) {
                alert("此商品尚未上架!!");
                vm.$router.push("/index");
              }
              vm.product.more = res.data.more; //最多能買
              vm.product.less = res.data.less; //最少須買
              vm.product.unit = res.data.unit; //數量倍數
              vm.optionTmp = res.data.standards;
              if (vm.product.stockStatus == 1) vm.canbuyText = "已售完";
              if (vm.product.stockStatus == 2) vm.canbuyText = "補貨中";
              if (vm.product.standards[0][0]) {
                vm.productRealCost = vm.product.standards[0][0].realCost; //判斷如有規格近來頁面給的初始實際成本價
                vm.productCost = vm.product.standards[0][0].cost; //判斷如有規格近來頁面給的初始成本價
                vm.productPrice = vm.product.standards[0][0].wholesale; //判斷如有規格近來頁面給的初始批發價
              }


              //有規格時
              for (let i = 0; i < vm.optionTmp.length; i++) {
                vm.option[i] = {};

                const obj = vm.optionTmp[i];
                const arr = Object.keys(obj);
                let len = arr.length - 2;
                for (let j = 0; j < len; j++) {
                  vm.option[i][j] = {};
                  if (i == 0 && vm.product.preOrder) vm.option[i][j].text = vm.optionTmp[i][j].name;
                  else if (i == 0) vm.option[i][j].text = vm.optionTmp[i][j].name
                  else vm.option[i][j].text = vm.optionTmp[i][j].name;
                  vm.option[i][j].value = vm.optionTmp[i][j].id;
                  // vm.productLimit = optionTmp[i].quantityLimit;
                }
              }

              //無規格時
              if (!vm.option[0][0]) {
                vm.productLimit = vm.product.limitNum;
                vm.productRealCost = vm.product.productRealCost;
                vm.productCost = vm.product.productCost;
                vm.productPrice = vm.product.price;
              }

              // vm.product.path = `${process.env.IMGPATH}/` + vm.product.path;

              vm.getPictures();
            } else if (res.data == "noId") {
              alert("無此資料!!");
              vm.$router.push("/index");
            }
          })
          .catch(err => {
            console.log(err);
          });
      },
      //取得商品圖片
      getPictures() {
        const vm = this;
        const data = {
          id: vm.productId
        };
        const me_api = `${process.env.APIPATH}/getPictures`;
        axios
          .post(me_api, data)
          .then(res => {
            if (res.data) {
              // vm.product.path = `${process.env.IMGPATH}/` + res.data.data[0].path;
              for (let i = 0; i < res.data.data.length; i++) {
                vm.carouselIMG.push(
                  `${process.env.IMGPATH}/` + res.data.data[i].path
                );
              }
            } else if (res.data == "noId") {
              alert("無此資料!!");
              vm.$router.push("/index");
            }
          })
          .catch(err => {
            console.log(err);
          });
      },
      //判斷輸入數量
      updateValue(event) {},
      minNum() {
        if (this.productNum != this.product.unit) {
          this.productNum -= parseInt(this.product.unit);
        } else {
          this.productNum = parseInt(this.product.unit);
        }
      },
      //加入購物車
      addtoCart(qty) {
        let vm = this;
        const obj = vm.selectId;
        const arr = Object.keys(obj);
        let len = arr.length;

        if (qty == "") qty = 1;
        //檢查是否下架或刪除
        let today = new Date();
        let currentDateTime = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate() + ' ' + today
          .getHours() + ':' + today.getMinutes() + ':' + today.getSeconds();
        if (vm.product.status == 0 || vm.product.status == 2) {
          alert("此商品已遭下架或刪除，無法加入購物車!!");
          vm.$router.push("/index");
        } else if (Date.parse(vm.product.reservation) > Date.parse(currentDateTime)) {
          alert("此商品尚未上架!!");
          vm.$router.push("/index");
        } else if (vm.shop == 0 && vm.product.preOrder == 1) {
          alert("僅高級會員、代理商可預購商品");
        } else if (len != vm.option.length && vm.option[0][0]) {
          alert("請選擇規格");
        } else if (qty > vm.productLimit && vm.product.preOrder == 0 && vm.product.stockStatus) {
          alert("不可超出庫存量");
        } else if (qty % vm.product.unit != 0) {
          alert("數量需為" + vm.product.unit + "的倍數");
        } else if (vm.product.less > 0 && qty < vm.product.less) {
          alert("不可少於" + this.product.less);
        } else if (vm.product.more > 0 && qty > vm.product.more) {
          alert("不可超過" + this.product.more);
        } else {
          // vm.isLoading = true;
          const data = {
            id: vm.productId,
            standards: JSON.stringify(vm.selectId),
            qty,
            shopId: vm.shopId
          };

          const headers = {
            headers: {
              Authorization: "Bearer " + vm.token
            }
          };

          const api = `${process.env.APIPATH}/addCart`;
          axios
            .post(api, data, headers)
            .then(res => {
              const response = res.data;
              vm.isLoading = false;
              if (response.split(",")[0] == "okAdd") {
                vm.$bus.$emit("Navbar:updateCart");
                alert("新增成功");
              } else if (response == "noToken") {
                alert("請先登入帳號");
                this.$router.push("/login");
              }
            })
            .catch(err => {
              console.log(err);
            });
        }
      },
      //更改選項
      changeSelect() {
        const vm = this;
        const obj = vm.optionTmp[0];
        const arr = Object.keys(obj);
        let len = arr.length - 2;

        const selectObj = vm.selectId;
        const selectArr = Object.keys(selectObj);
        const select = selectArr[0];
        for (let i = 0; i < len; i++) {
          if (vm.selectId[select] == vm.optionTmp[0][i].id)
            vm.productLimit = vm.optionTmp[0][i].quantityLimit;

          if (vm.selectId[select] == vm.optionTmp[0][i].id) {
            vm.productRealCost = vm.optionTmp[0][i].realCost;
            vm.productCost = vm.optionTmp[0][i].cost;
            vm.productPrice = vm.optionTmp[0][i].wholesale;
          }

        }

      },
      hyperlink() {
        window.open(this.product.film);
      }
    },
    created: function () {
      const vm = this;
      vm.productId = vm.$route.params.productId;
      vm.shopId = localStorage.getItem("shopId");
      vm.getMe();
      vm.getGroup();

      if (vm.$route.params.shopId) vm.shopId = parseInt(vm.$route.params.shopId);
      localStorage.setItem("shopId", vm.shopId);
      var t = setTimeout(function () {
        vm.$bus.$emit("Navbar:shopId", vm.shopId);
      }, 2000);
    },
    watch: {
      productLimit: function () {
        const vm = this;
        if (vm.productLimit <= vm.product.stockLow) vm.bottonText = "預購";
        else vm.bottonText = "加入購物車";

        if (vm.product.stockStatus && vm.productLimit <= 0) {
          vm.canbuy = 0;
        } else vm.canbuy = 1;

        if (vm.productLimit == null) vm.productLimit = 9999;
      },
      productNum: function (newVlaue, oldValue) {
        if (newVlaue < 1) {
          this.productNum = oldValue
        }
        // if(this.productLimit < this.product.more){
        // 	alert('庫存不足');
        // } else if (newVlaue < 0) {
        // 	alert("不可小於0");
        // 	this.productNum = oldValue;
        // } else if(this.productLimit && this.product.more > 0 && this.product.more > newVlaue){
        // 	alert("不可少於"+this.product.more);
        // 	this.productNum = this.product.more;
        // } else if(this.productLimit && this.product.less > 0 && this.product.less < newVlaue){
        // 	alert("不可超過"+this.product.less);
        // 	this.productNum = this.product.less;
        // } else if (newVlaue > this.productLimit){
        // 	alert(newVlaue + "已超出庫存量");
        // 	this.productNum = this.productLimit;
        // } else if (newVlaue <= this.productLimit) {
        // 	this.productNum = newVlaue;
        // }
      }
      // selectId: function() {

      // for (let i = 0; i < this.productAll.length; i++) {
      // 	if (this.selectId == this.productAll[i].id) this.productLimit = this.productAll[i].limitNum;
      // 	if (this.productLimit == null) this.productLimit = 9999;
      // }
      // }
    },
    // mounted() {
    //   this.$nextTick(() => {
    //     const swiperTop = this.$refs.swiperTop.$swiper;
    //     const swiperThumbs = this.$refs.swiperThumbs.$swiper;
    //     swiperTop.controller.control = swiperThumbs;
    //     swiperThumbs.controller.control = swiperTop;
    //   });
    // }
  };

</script>
<style lang="scss" scoped>
  .thumb-example {
    height: 480px;
  }

  .swiper {
    .swiper-slide {
      background-size: cover;
      background-position: center;
    }

    &.gallery-top {
      height: 80%;
      width: 100%;
    }

    &.gallery-thumbs {
      height: 20%;
      box-sizing: border-box;
    }

    &.gallery-thumbs .swiper-slide {
      width: 25%;
      height: 100%;
      opacity: 0.4;
    }

    &.gallery-thumbs .swiper-slide-active {
      opacity: 1;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/page/productDetailed.vue